<template>
  <b-nav-item-dropdown
    id="show_noty"
    ref="refCloseDropdown"
    class="dropdown-notification "
    menu-class="dropdown-menu-media"
    right
    @show="getAllNoty"
  >
    <template #button-content>
      <feather-icon
        :badge="total"
        badge-classes="bg-danger amount_noty"
        icon="BellIcon"
        size="21"
      />
    </template>
    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t('Notifications') }}
        </h4>
        <b-badge
          pill
          variant="light-primary"
        > {{ notifications.length > 0 ? notifications.length : '' }} {{ $t('New') }} </b-badge>
      </div>
    </li>
    <li
      v-if="!notifications.length"
      class="media-list"
    >
      <p class="text-center mt-1">
        Không có thông báo mới
      </p>
    </li>
    <li
      v-else
      class="media-list"
      :class="showHidden"
    >
      <p class="text-center mt-1">
        Đang tải dữ liệu
      </p>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list notification-scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link
        v-for="(item, index) in notifications"
        :key="item.id"
        class="media-list"
        @click="readNoty(item, index)"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :src="item.avatar"
              :text="item.avatar"
              variant="light-primary"
            />
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder"> {{ item.title }} </span>
          </p>
          <small
            v-if="item.subtitle"
            class="notification-text"
          >{{ item.subtitle }}</small>
        </b-media>
      </b-link>

      <!-- <b-link
        v-for="notification in systemNotifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="notification.type"
            >
              <feather-icon :icon="notification.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->
    </vue-perfect-scrollbar>

    <!-- Footer -->
    <li
      v-if="notifications.length"
      class="dropdown-menu-footer"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        :to="{ name: 'notification-personal' }"
        block
      >Xem tất cả</b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  onMounted, ref, computed,
} from '@vue/composition-api'
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import router from '@/router'
import { useRouter } from '@core/utils/utils';

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      loadingData: false,
      showHidden: '',
    }
  },
  methods: {
    getAllNoty() {
      store.dispatch('noty/fetchAll', { isPaginate: 0 })
        .then(response => {
          if (response.status === 200) {
            this.showHidden = 'hidden';
            this.notifications = response.data.data
            // console.log('this.notifications', this.notifications);
            this.loadingData = false;
          }
        })
    },
  },
  setup(props, context) {
    const loadingData = ref(false)
    const refCloseDropdown = ref(null);
    const { route } = useRouter();
    /* eslint-disable global-require */
    const notifications1 = [
      {
        title: 'Chúc mừng bạn 🎉',
        avatar: require('@/assets/images/avatars/default_avatar.jpg'),
        subtitle: 'Bạn đã được thăng hạng',
        type: 'light-success',
      },
      {
        title: 'Có tin nhắn mới',
        avatar: require('@/assets/images/avatars/default_avatar.jpg'),
        subtitle: 'Bạn có 10 tin nhắn chưa đọc',
        type: 'light-info',
      },
      {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      }, {
        title: 'Có người muốn nhờ bạn xử lý tin 👋',
        avatar: 'MD',
        subtitle: 'Tin nóng',
        type: 'light-danger',
      },
    ]
    const dropOpen = ref(false)

    const notifications = ref([]);

    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]
    const total = computed({
      get() {
        return store.state.noty.total
      },
      set(val) {
        store.dispatch('noty/setTotal', val)
      },
    })
    onMounted(() => {

    })

    store.dispatch('noty/getTotal')
      .then(response => {
        if (response.status === 200) {
          total.value = response.data.data
          // console.log('response', total.value);
        }
      })
    // notifications.value = notifications1;

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
      // wheelPropagation: false,
    }
    const readNoty = (item, index) => {
      store.dispatch('noty/read', item.id)
        .then(response => {
          if (response.status === 200) {
            total.value -= 1;
            // console.log('refCloseDropdown', refCloseDropdown);
            refCloseDropdown.value.hide(true)
            // console.log('index', index);
            notifications.value.splice(index, 1)
            // console.log(' notifications.value', notifications.value);
            // console.log(route.value)
            if (item.url !== route.value.path) {
              router.push({ path: item.url })
            }
          }
        })
    }

    return {
      notifications1,
      notifications,
      total,
      systemNotifications,
      perfectScrollbarSettings,
      dropOpen,
      readNoty,
      loadingData,
      refCloseDropdown,
    }
  },
}
</script>
<style lang="scss">
.notification-scroll-area {
  position: relative;
  max-height: 400px;
}
</style>
